import { makeStyles } from "@mui/styles";

const cardShadow = "0 12px 28px rgba(18, 38, 63, 0.1)";

const useStyles = makeStyles(() => ({
  dashboardPage: {
    minHeight: "100%",
    color: "#0f2137",
    position: "relative",
    overflow: "hidden",
    zoom:0.8,
    "&::after": {
      content: '""',
      position: "absolute",
      right: -4,
      bottom: -8,
      width: 300,
      height: 154,
      backgroundImage: "radial-gradient(circle, rgba(39, 75, 102, 0.13) 1.5px, transparent 1.5px)",
      backgroundSize: "9px 9px",
      opacity: 0.55,
      pointerEvents: "none",
    },
  },
  pageDecor: {
    position: "absolute",
    right: -2,
    top: -46,
    width: 140,
    height: 330,
    backgroundImage: "radial-gradient(circle, rgba(39, 75, 102, 0.13) 1.5px, transparent 1.5px)",
    backgroundSize: "9px 9px",
    opacity: 0.55,
    pointerEvents: "none",
  },
  dashboardTopbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 24,
    marginBottom: 35,
    position: "relative",
    zIndex: 1,
  },
  pageIntro: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    "& p": {
      margin: 0,
      color: "#5f6f84",
      fontSize: "14px !important",
      fontWeight: "600 !important",
      paddingLeft: 17,
      marginLeft: 40,
      borderLeft: "2px solid #12a869",
      lineHeight: "18px !important",
    },
  },
  pageTitleWrap: {
    display: "flex",
    alignItems: "center",
    gap: 22,
    "& h3": {
      margin: "0 !important",
      fontSize: "34px !important",
      lineHeight: "42px !important",
      fontWeight: "900 !important",
      color: "#0e2038",
      letterSpacing: 0,
    },
  },
  titleIcon: {
    color: "#0e2038",
    fontSize: "34px !important",
  },
  filters: {
    display: "flex",
    alignItems: "center",
    gap: 24,
    paddingRight: 8,
    "& .MuiTextField-root": {
      width: 194,
      background: "#fff",
      borderRadius: 10,
    },
    "& .MuiInputBase-root": {
      minHeight: 49,
      borderRadius: 10,
      background: "#fff",
      boxShadow: "0 8px 18px rgba(18, 38, 63, 0.07)",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#dbe5ef !important",
    },
    "& .MuiInputBase-input": {
      padding: "14px 16px !important",
      color: "#64758d",
      fontSize: "13px !important",
      fontWeight: 700,
    },
    "& .MuiInputLabel-root": {
      color: "#64758d",
      fontSize: "13px !important",
      fontWeight: 700,
      transform: "translate(16px, 15px) scale(1)",
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(16px, -7px) scale(0.76)",
    },
    "& .MuiSvgIcon-root": {
      color: "#2d4059",
      fontSize: 22,
    },
  },
  exportButton: {
    minHeight: "49px !important",
    minWidth: "178px !important",
    borderRadius: "10px !important",
    background: "linear-gradient(180deg, #00623f 0%, #004832 100%) !important",
    color: "#fff !important",
    fontSize: "12px !important",
    fontWeight: "900 !important",
    boxShadow: "0 12px 22px rgba(0, 87, 58, 0.24) !important",
    "& .MuiButton-startIcon": {
      marginRight: 10,
    },
    "& .MuiSvgIcon-root": {
      fontSize: "21px !important",
    },
    "&:hover": {
      background: "linear-gradient(180deg, #006b45 0%, #004d35 100%) !important",
    },
  },
  root: {
    position: "relative",
    zIndex: 1,
    rowGap: 2,
  },
  card: {
    minHeight: 187,
    height: "100%",
    padding: "28px 27px 24px",
    borderRadius: 12,
    background: "#fff",
    border: "1px solid #e8eef5",
    borderLeft: "3px solid #20c997",
    boxShadow: cardShadow,
    position: "relative",
    overflow: "hidden",
    "&::after": {
      content: '""',
      position: "absolute",
      right: -28,
      bottom: -16,
      width: 150,
      height: 82,
      opacity: 0.58,
      pointerEvents: "none",
      borderRadius: "70% 0 0 0",
    },
  },
  compactCard: {
    minHeight: 187,
  },
  greenWave: {
    borderLeftColor: "#25c7a2",
    "&::after": {
      background:
        "repeating-radial-gradient(ellipse at right bottom, rgba(41, 207, 168, 0.16) 0 2px, transparent 2px 5px), linear-gradient(135deg, transparent 20%, rgba(41, 207, 168, 0.1) 100%)",
    },
  },
  redWave: {
    borderLeftColor: "#ff7d93",
    "&::after": {
      background: "linear-gradient(135deg, transparent 18%, rgba(255, 125, 147, 0.16) 100%)",
    },
  },
  blueWave: {
    borderLeftColor: "#66b7f7",
    "&::after": {
      background: "linear-gradient(135deg, transparent 18%, rgba(102, 183, 247, 0.14) 100%)",
    },
  },
  amberWave: {
    borderLeftColor: "#ffbc63",
    "&::after": {
      background: "linear-gradient(135deg, transparent 18%, rgba(255, 188, 99, 0.15) 100%)",
    },
  },
  purpleWave: {
    borderLeftColor: "#b37bff",
    "&::after": {
      background: "linear-gradient(135deg, transparent 18%, rgba(179, 123, 255, 0.15) 100%)",
    },
  },
  orangeWave: {
    borderLeftColor: "#ff795f",
    "&::after": {
      background: "linear-gradient(135deg, transparent 18%, rgba(255, 121, 95, 0.14) 100%)",
    },
  },
  cardContent: {
    display: "flex",
    alignItems: "flex-start",
    gap: 22,
  },
  nameLabel: {
    minHeight: 24,
    "& .MuiTypography-root": {
      margin: 0,
      color: "#12223a",
      fontSize: "14px !important",
      lineHeight: "18px !important",
      fontWeight: "900 !important",
    },
  },
  count: {
    marginTop: 8,
    "& .MuiTypography-root": {
      color: "#0f2137",
      fontSize: "34px !important",
      lineHeight: "42px !important",
      fontWeight: "900 !important",
      letterSpacing: 0,
      whiteSpace: "nowrap",
    },
  },
  trend: {
    marginTop: 18,
    height: 38,
    padding: "0 16px",
    borderRadius: 20,
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    fontSize: 14,
    fontWeight: 900,
    whiteSpace: "nowrap",
    "& .MuiSvgIcon-root": {
      fontSize: 20,
    },
    "& em": {
      marginLeft: 16,
      color: "#667790",
      fontSize: 12,
      fontStyle: "normal",
      fontWeight: 700,
      background: "transparent",
      height: "auto",
      padding: 0,
      borderRadius: 0,
    },
  },
  up: {
    color: "#007b4d",
    background: "#dff4e9",
  },
  down: {
    color: "#f0182d",
    background: "#ffe4e9",
  },
  flat: {
    color: "#233952",
    background: "#edf3f8",
  },
  flatTag: {
    "& .MuiSvgIcon-root": {
      fontSize: 18,
    },
  },
  iconBadge: {
    width: 66,
    height: 66,
    borderRadius: 999,
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
    boxShadow: "0 12px 22px rgba(18, 38, 63, 0.13)",
    "& .MuiSvgIcon-root": {
      fontSize: 34,
    },
  },
  green: {
    background: "radial-gradient(circle at 35% 30%, #e4fbef 0%, #bdf0d4 100%)",
    color: "#058952",
  },
  red: {
    background: "radial-gradient(circle at 35% 30%, #ffe8ed 0%, #ffc8d2 100%)",
    color: "#e5142f",
  },
  blue: {
    background: "radial-gradient(circle at 35% 30%, #e5f3ff 0%, #bedfff 100%)",
    color: "#0872bf",
  },
  amber: {
    background: "radial-gradient(circle at 35% 30%, #fff2de 0%, #ffd9a4 100%)",
    color: "#f08a08",
  },
  purple: {
    background: "radial-gradient(circle at 35% 30%, #f2e8ff 0%, #d8b9ff 100%)",
    color: "#7426cb",
  },
  orange: {
    background: "radial-gradient(circle at 35% 30%, #ffe9db 0%, #ffc5a9 100%)",
    color: "#f05b11",
  },
  "@media (max-width: 1200px)": {
    dashboardTopbar: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
    filters: {
      flexWrap: "wrap",
      paddingRight: 0,
    },
  },
  "@media (max-width: 720px)": {
    pageTitleWrap: {
      gap: 12,
      "& h3": {
        fontSize: "28px !important",
        lineHeight: "34px !important",
      },
    },
    filters: {
      width: "100%",
      "& .MuiTextField-root": {
        width: "100%",
      },
    },
    exportButton: {
      width: "100%",
    },
  },
}));

export default useStyles;
